import React from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { Dropdown } from 'semantic-ui-react';
import { UPDATE_CURRENT_TEAM } from '../../queries/profile';

const TeamDropdown = ({ user }) => {
  const client = useApolloClient();
  const [updateCurrentTeam, { loading: updatingCurrentTeam }] = useMutation(UPDATE_CURRENT_TEAM);
  const currentTeamId = user.currentTeam?.id;
  const currentTeamName = user.currentTeam?.name;

  const onSwitchTeam = async (newTeamId) => {
    if (!newTeamId || newTeamId === currentTeamId) return;

    await updateCurrentTeam({
      variables: { teamId: newTeamId },
    });

    await client.resetStore();
  };

  return (
    <Dropdown item text={`Team: ${currentTeamName || 'No team'}`}>
      <Dropdown.Menu direction="left">
        {(user.membership || []).map((membership) => (
          <Dropdown.Item
            key={membership.teamId}
            disabled={updatingCurrentTeam || membership.teamId === currentTeamId}
            text={membership.teamName}
            onClick={async () => {
              await onSwitchTeam(membership.teamId);
            }}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TeamDropdown;
